import type { DistanceUnit } from 'lib/geo/distanceUnits'
import { kmToMiles } from 'lib/geo/distanceUnits'
import type { IntlShape } from 'react-intl'

export function getDistanceLabel(
  distanceKm: number,
  distanceFrom: string,
  distanceUnitOutput: DistanceUnit,
  intl: IntlShape,
): string | null {
  if (distanceKm > 20) {
    return null
  }
  if (distanceUnitOutput === 'km') {
    if (distanceKm < 0.1) {
      const meters = (distanceKm * 1000).toFixed(1)
      const formattedMeters = meters.replace(/\.0$/, '')
      return intl.formatMessage(
        {
          id: '26AKl1GIp4DnEhDJnT2m',
          defaultMessage: '{distance}m from {distanceFrom}',
        },
        {
          distance: formattedMeters,
          distanceFrom,
        },
      )
    }

    const formattedKm = distanceKm.toFixed(1).replace(/\.0$/, '')
    return intl.formatMessage(
      {
        id: 'YQRxMucPozQTqKjv9cY_',
        defaultMessage: '{distance}km from {distanceFrom}',
      },
      {
        distance: formattedKm,
        distanceFrom,
      },
    )
  }
  if (distanceUnitOutput === 'mi') {
    const miles = kmToMiles(distanceKm)
    const formattedMiles = miles.toFixed(1).replace(/\.0$/, '')
    return intl.formatMessage(
      {
        id: 'Q43dSThoj88IsLzEYthb',
        defaultMessage: '{distance} mi from {distanceFrom}',
      },
      {
        distance: formattedMiles,
        distanceFrom,
      },
    )
  }
  return null
}
